export class Reservation {
    studentId: number;
    command: {
        classId: number;
    }
}
export class CancelReservation {
    studentId: number;
    classId: number;
}
export class BookingInfo {
    studentId: number;
    classes: any[]
}


// WEBPACK FOOTER //
// ./src/holiday/models/Reservation.ts